import { apiClient } from '@/lib/api.ts'

export function testEsetConnection(payload: Record<string, unknown>) {
  return apiClient.post('/eset/test-connection', payload)
}
